var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 129,
    viewBox: "0 0 158 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 30.5216C158 66.0666 100.033 129 64.4423 129C28.8518 129 0 100.185 0 64.6401C0 29.0951 28.8518 0.280148 64.4423 0.280148C100.033 0.280148 158 -5.02345 158 30.5216Z",
    fill: "url(#paint0_linear_1_5890)",
    fillOpacity: 0.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6735 91.1665H55.7568C54.1527 91.1665 52.8402 89.854 52.8402 88.2498V50.3332C52.8402 48.729 51.5277 47.4165 49.9235 47.4165C48.3193 47.4165 47.0068 48.729 47.0068 50.3332V88.2498C47.0068 93.0623 50.9443 96.9998 55.7568 96.9998H93.6735C95.2777 96.9998 96.5902 95.6873 96.5902 94.0832C96.5902 92.479 95.2777 91.1665 93.6735 91.1665Z",
    fill: "url(#paint1_linear_1_5890)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.494 42.4292L89.911 27.8458C89.3568 27.3208 88.6277 27 87.8402 27H58.6735C57.0693 27 55.7568 28.3125 55.7568 29.9167C55.7568 31.5208 57.0693 32.8333 58.6735 32.8333H82.0068V47.4167C82.0068 49.0208 83.3193 50.3333 84.9235 50.3333H99.5068V73.6667C99.5068 75.2708 100.819 76.5833 102.424 76.5833C104.028 76.5833 105.34 75.2708 105.34 73.6667V44.5C105.34 43.7125 105.019 42.9833 104.494 42.4292ZM87.8402 44.5V34.0292L98.311 44.5H87.8402Z",
    fill: "url(#paint2_linear_1_5890)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.424 91.1664C101.666 91.1664 100.936 90.8748 100.353 90.3206L47.8531 37.8206C46.7156 36.6831 46.7156 34.8456 47.8531 33.7081C48.9906 32.5706 50.8281 32.5706 51.9656 33.7081L104.466 86.2081C105.603 87.3456 105.603 89.1831 104.466 90.3206C103.911 90.8748 103.182 91.1664 102.424 91.1664Z",
    fill: "url(#paint3_linear_1_5890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5890",
    x1: 79,
    y1: 0,
    x2: 79,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5890",
    x1: 71.7985,
    y1: 47.4165,
    x2: 71.7985,
    y2: 96.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69CC96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14C364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_5890",
    x1: 80.5485,
    y1: 27,
    x2: 80.5485,
    y2: 76.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69CC96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14C364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_5890",
    x1: 76.1594,
    y1: 32.855,
    x2: 76.1594,
    y2: 91.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69CC96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14C364"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.8531ae135a1303aca508767302528ed3.svg";
export { ForwardRef as ReactComponent };